import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { isEmpty } from 'lodash';
import useUsers from '../useUsers';

interface IAutocompleteInputUsersProps {
  multiple?: boolean;
  value: any;
  name?: string;
  error?: boolean;
  helperText?: string;
  handleChange: any;
  onlyCollaborators?: boolean;
}
const AutocompleteInputUsers = ({
  multiple,
  value,
  name = 'collaborators',
  handleChange,
  error,
  helperText,
  onlyCollaborators,
}: IAutocompleteInputUsersProps) => {
  const { users, usersWithoutAuthUser } = useUsers();

  return (
    <Autocomplete
      multiple={multiple}
      filterSelectedOptions
      options={(onlyCollaborators ? usersWithoutAuthUser : users) ?? []}
      getOptionLabel={(option) => {
        return !isEmpty(option) ? `${option.fullName}` : '';
      }}
      getOptionSelected={(option, value) => {
        return option.idIri === value.idIri;
      }}
      value={value ?? []}
      onChange={(evt, value) => {
        handleChange(name, value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Collaborateur(s) autorisé(s)"
          placeholder="Collaborateur(s)"
          name={name}
          InputLabelProps={{
            shrink: true,
          }}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export default AutocompleteInputUsers;
